export default __webpack_public_path__ + "static/media/Honeywell AIDC.fe2772ae.png";